/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicGovernanceNotification extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicGovernanceNotification");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicGovernanceNotification.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicGovernanceNotification>): BackgroundJobPayloadForPeriodicGovernanceNotification {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicGovernanceNotification(), model);
        BackgroundJobPayloadForPeriodicGovernanceNotification.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicGovernanceNotification>): BackgroundJobPayloadForPeriodicGovernanceNotification {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicGovernanceNotification.newInstance(<BackgroundJobPayloadForPeriodicGovernanceNotification> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicGovernanceNotification) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicGovernanceNotification.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicGovernanceNotification): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicGovernanceNotification.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
